export default __webpack_public_path__ + "static/media/icon-medical-leave-am.ba45530c.svg";